<template>
  <div class="main">
    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    ></SearchField>

    <Table
      ref="table"
      :tableHeight="tableHeight"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :getTotal="getTotal"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
      <template slot="photo" slot-scope="params">
        <div class="photos">
          <div
            class="wrap"
            v-for="(c, i) in params.params.reimburse_bill"
            :key="'reimburse_bill' + i"
          >
            <el-image
              class="img"
              :src="c.url"
              :preview-src-list="params.params.urls"
            ></el-image>
          </div>
        </div>
        <span v-if="!params.params.reimburse_bill || !params.params.reimburse_bill[0]"
          >-</span
        >
      </template>
      <template slot="status" slot-scope="params">
        <span v-if="params.params.is_pay === 1">已打款</span>
        <span v-else style="color: #f56c6c">未打款</span>
      </template>
      <template slot="operation" slot-scope="params">
        <el-button
          v-if="params.params.is_pay !== 1"
          type="primary"
          size="mini"
          @click="showPay(params.params)"
          >打款</el-button
        >
        <el-button
          v-if="params.params.is_pay === 1"
          type="text"
          @click="showPayed(params.params)"
          >打款凭证</el-button
        >
      </template>
    </Table>

    <FormDialog
      class="dialog"
      ref="dialog"
      :title="title"
      :width="'350px'"
      :labelWidth="'0px'"
      :form="mform"
      :rules="mrules"
      :formCtrl="mformCtrl"
      :viewMode="viewMode"
      @onModalSubmit="onModalSubmit"
    ></FormDialog>

    <FormDialog
      class="dialog"
      ref="dialog2"
      :title="title"
      :width="'350px'"
      :labelWidth="'0px'"
      :form="mform2"
      :rules="mrules"
      :formCtrl="mformCtrl2"
      :viewMode="true"
    ></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "reimburse",
      getOptionUrl: "options",
      modalSubmitUrl: "pay",
      formInline: {
        status: 1,
      },
      baseParams: ["group_name", "status"],
      formCtrl: [
        {
          label: "报销人",
          keyName: "reimburse_user_name",
          placeholder: "请选择报销人",
          type: "select",
          options: [],
        },
        {
          label: "打款状态",
          keyName: "is_pay",
          placeholder: "请选择打款状态",
          type: "select",
          options: [
            { label: "未打款", value: "0" },
            { label: "已打款", value: "1" },
          ],
        },
        {
          label: "申请时间",
          keyName: "apply_at",
          placeholder: "请选择时间",
          type: "daterange",
        },
      ],
      cols: [
        { prop: "reimburse_user_name", label: "报销人" },
        { prop: "reimburse_content", label: "报销事项" },
        { prop: "reimburse_amount", label: "报销金额" },
        { prop: "apply_at", label: "申请时间" },
        { prop: "reimburse_bill", label: "票据", slot: "photo" },
        { prop: "is_pay", label: "打款状态", slot: "status" },
      ],
      title: "打款凭证",
      viewMode: false,
      mform: {},
      mform2: {},
      mrules: {},
      mformCtrl: [
        {
          label: "",
          keyName: "pay_bill",
          type: "file",
        },
      ],
      mformCtrl2: [
        {
          label: "",
          keyName: "pay_bill",
          type: "file",
          disabled: true,
          viewMode: true,
        },
      ],
    };
  },
  methods: {
    tableDataHandler(res) {
      if (typeof res === "string") {
        this.$message({
          type: "error",
          message: res,
        });
      } else {
        const { count, data } = res;
        this.total = count;
        if (data && data.length) {
          this.tableData = data.map((v) => {
            const obj = this.dataObjHandler(v);
            obj.urls = [];
            // console.log({ ...obj })
            const { reimburse_bill, pay_bill } = obj;
            // 预览图片
            if (reimburse_bill && reimburse_bill.length) {
              reimburse_bill.map((o) => {
                obj.urls.push(o.url);
              });
            }
            if (pay_bill && pay_bill.length) {
              pay_bill.map((o) => {
                obj.urls.push(o.url);
              });
            }
            return obj;
          });
        }
      }
    },
    showPay({ id }) {
      this.$set(this.mform, "id", id);
      // this.$set(this.mform, 'pay_bill', pay_bill)
      this.showDialog();
    },
    showPayed({ id, pay_bill }) {
      this.$set(this.mform2, "id", id);
      this.$set(this.mform2, "pay_bill", pay_bill);
      this.showDialog("dialog2");
    },
    setOptions({ data: { reimburse_user_list } }) {
      this.formCtrl.map((c) => {
        if (
          c.keyName == "reimburse_user_name" &&
          reimburse_user_list &&
          reimburse_user_list.length
        ) {
          c.options = reimburse_user_list.map((v) => {
            return {
              label: v.nickname,
              value: v.nickname,
            };
          });
          // console.log(c.options)
        }
      });
      this.$forceUpdate();
    },
  },
  mounted() {
    this.getOptions();
    const { user_group_id, group_name } = this.user;
    // 财务权限
    if ([2, 3, 4].includes(user_group_id) && group_name == "Cashier") {
      this.cols.push({ prop: "", label: "打款操作", slot: "operation" });
    }
    this.$set(this.formInline, "group_name", group_name);
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .table-wrap {
    .el-table {
      .cell {
        img {
          width: 100%;
          height: 100%;
        }
      }

      .el-image {
        max-height: 50px;
        max-width: 50px;
      }

      .photos {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .wrap {
          width: 50px;
          height: 50px;
          border: 1px solid #bbb;
          box-sizing: border-box;
          border-radius: 5px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.dialog {
  /deep/ .el-dialog {
    .el-dialog__header {
      padding: 15px 20px 0;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-form {
      padding-right: 0;
      margin: 20px;

      .el-form-item .el-form-item__content {
        .content {
          display: block;
        }

        .showUpload {
          display: flex;
          justify-content: center;

          .showimg {
            &:nth-child(3n) {
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>
